import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type PaymentsProps = IconComponentBaseProps;

export const Payments = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: PaymentsProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_7353_411055"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7353_411055)">
        <path
          d="M9.1663 8.4735C8.70052 8.4735 8.3063 8.31217 7.98363 7.98951C7.66097 7.66684 7.49964 7.27262 7.49964 6.80684C7.49964 6.34106 7.66097 5.94684 7.98363 5.62417C8.3063 5.30151 8.70052 5.14017 9.1663 5.14017C9.63208 5.14017 10.0263 5.30151 10.349 5.62417C10.6716 5.94684 10.833 6.34106 10.833 6.80684C10.833 7.27262 10.6716 7.66684 10.349 7.98951C10.0263 8.31217 9.63208 8.4735 9.1663 8.4735ZM4.7688 10.5377C4.43747 10.5377 4.1538 10.4197 3.9178 10.1837C3.6818 9.94767 3.5638 9.66395 3.5638 9.33251V4.28117C3.5638 3.94984 3.6818 3.66617 3.9178 3.43017C4.1538 3.19417 4.43747 3.07617 4.7688 3.07617H13.5636C13.8951 3.07617 14.1788 3.19417 14.4148 3.43017C14.6508 3.66617 14.7688 3.94984 14.7688 4.28117V9.33251C14.7688 9.66395 14.6508 9.94767 14.4148 10.1837C14.1788 10.4197 13.8951 10.5377 13.5636 10.5377H4.7688ZM5.7688 9.53767H12.5638C12.5638 9.20523 12.6818 8.92123 12.9178 8.68567C13.1538 8.45023 13.4375 8.3325 13.7688 8.3325V5.28117C13.4364 5.28117 13.1524 5.16317 12.917 4.92717C12.6815 4.69117 12.5638 4.40751 12.5638 4.07617H5.7688C5.7688 4.40862 5.6508 4.69256 5.4148 4.928C5.1788 5.16345 4.89514 5.28117 4.5638 5.28117V8.3325C4.89625 8.3325 5.18019 8.4505 5.41563 8.6865C5.65108 8.9225 5.7688 9.20623 5.7688 9.53767ZM12.2816 12.871H2.43564C2.10419 12.871 1.82047 12.753 1.58447 12.517C1.34847 12.281 1.23047 11.9973 1.23047 11.6658V5.56334C1.23047 5.42167 1.27841 5.30289 1.3743 5.207C1.47019 5.11123 1.58897 5.06334 1.73064 5.06334C1.87241 5.06334 1.99114 5.11123 2.0868 5.207C2.18258 5.30289 2.23047 5.42167 2.23047 5.56334V11.6658C2.23047 11.7171 2.2518 11.7641 2.29447 11.8068C2.33725 11.8496 2.3843 11.871 2.43564 11.871H12.2816C12.4233 11.871 12.5421 11.9189 12.638 12.0148C12.7337 12.1106 12.7816 12.2294 12.7816 12.3712C12.7816 12.5129 12.7337 12.6317 12.638 12.7273C12.5421 12.8231 12.4233 12.871 12.2816 12.871ZM4.7688 9.53767H4.5638V4.07617H4.7688C4.71325 4.07617 4.66519 4.09645 4.62464 4.13701C4.58408 4.17756 4.5638 4.22562 4.5638 4.28117V9.33251C4.5638 9.38806 4.58408 9.43612 4.62464 9.47667C4.66519 9.51734 4.71325 9.53767 4.7688 9.53767Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
